import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { fetchSiivousTila } from '@/services/siivousService';

export const useSiivousStatus = (tuoteId) => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!tuoteId) return;

    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await fetchSiivousTila(tuoteId, dayjs().toISOString());
        if (!cancelled) setStatus(res);
      }
      catch (e) {
        if (!cancelled) setError(e);
      }
      finally {
        if (!cancelled) setLoading(false);
      }

      return () => {
        cancelled = true;
      };
    })();
  }, [tuoteId]);

  return { status, loading, error, setStatus };
};
